import { Mtds, XIcon } from 'prove-common'
import { ALL_FILTER_VALUE } from './statisticsFilterUtils'
import type { FilterOption } from './statisticsTypes'

type StatisticsSelectFieldProps = {
  label: string
  options: FilterOption[]
  selectedValue: string
  disabled?: boolean
  onSelectedChange: (value: string) => void
}

const StatisticsSelectField = ({
  label,
  options,
  selectedValue,
  disabled = false,
  onSelectedChange
}: StatisticsSelectFieldProps) => (
  <Mtds.Field
    as='select'
    label={label}
    value={selectedValue}
    disabled={disabled}
    onChange={({ target }) => onSelectedChange(target.value)}
    options={options}
  />
)

export const StatisticsFilters = ({
  selectedYear,
  yearOptions,
  selectedPlan,
  regionOptions,
  selectedRegionId,
  avdelingOptions,
  selectedAvdelingId,
  seksjonOptions,
  selectedSeksjonId,
  teamOptions,
  selectedTeamId,
  selectedEftaNumber,
  eftaNumberOptions,
  isLoadingPlans,
  planOptions,
  currentYear,
  resetOrgFilters,
  setSelectedYear,
  setSelectedRegionId,
  setSelectedAvdelingId,
  setSelectedSeksjonId,
  setSelectedTeamId,
  setSelectedEftaCode,
  onSelectedPlanChange
}: {
  selectedYear: number
  yearOptions: FilterOption[]
  selectedPlan: number | undefined
  regionOptions: FilterOption[]
  selectedRegionId: string
  avdelingOptions: FilterOption[]
  selectedAvdelingId: string
  seksjonOptions: FilterOption[]
  selectedSeksjonId: string
  teamOptions: FilterOption[]
  selectedTeamId: string
  selectedEftaNumber: string
  eftaNumberOptions: FilterOption[]
  isLoadingPlans: boolean
  planOptions: FilterOption[]
  currentYear: number
  resetOrgFilters: () => void
  setSelectedYear: (year: number) => void
  setSelectedRegionId: (value: string) => void
  setSelectedAvdelingId: (value: string) => void
  setSelectedSeksjonId: (value: string) => void
  setSelectedTeamId: (value: string) => void
  setSelectedEftaCode: (value: string) => void
  onSelectedPlanChange: (value: number | undefined) => void
}) => {
  const isFiltering =
    selectedYear !== currentYear ||
    selectedPlan !== undefined ||
    selectedRegionId !== ALL_FILTER_VALUE ||
    selectedAvdelingId !== ALL_FILTER_VALUE ||
    selectedSeksjonId !== ALL_FILTER_VALUE ||
    selectedTeamId !== ALL_FILTER_VALUE ||
    selectedEftaNumber !== ALL_FILTER_VALUE

  return (
    <Mtds.Grid data-items={250}>
      <Mtds.Field
        as='select'
        label='År'
        value={selectedYear.toString()}
        onChange={({ target }) => setSelectedYear(Number(target.value))}
        options={yearOptions}
      />
      <StatisticsSelectField
        label='Divisjon'
        selectedValue={selectedRegionId}
        onSelectedChange={(value) => {
          setSelectedRegionId(value)
          setSelectedAvdelingId(ALL_FILTER_VALUE)
          setSelectedSeksjonId(ALL_FILTER_VALUE)
          setSelectedTeamId(ALL_FILTER_VALUE)
        }}
        options={regionOptions}
      />
      <StatisticsSelectField
        label='Avdeling'
        selectedValue={selectedAvdelingId}
        onSelectedChange={(value) => {
          setSelectedAvdelingId(value)
          setSelectedSeksjonId(ALL_FILTER_VALUE)
          setSelectedTeamId(ALL_FILTER_VALUE)
        }}
        options={avdelingOptions}
      />
      <StatisticsSelectField
        label='Seksjon'
        selectedValue={selectedSeksjonId}
        onSelectedChange={(value) => {
          setSelectedSeksjonId(value)
          setSelectedTeamId(ALL_FILTER_VALUE)
        }}
        options={seksjonOptions}
      />
      <StatisticsSelectField
        label='Team'
        selectedValue={selectedTeamId}
        onSelectedChange={setSelectedTeamId}
        options={teamOptions}
      />
      <StatisticsSelectField
        label='EFTA-nummer'
        selectedValue={selectedEftaNumber}
        onSelectedChange={setSelectedEftaCode}
        options={eftaNumberOptions}
      />
      {isLoadingPlans ? (
        <>
          <Mtds.Spinner />
          <span>Laster planer</span>
        </>
      ) : (
        <StatisticsSelectField
          label='Plan'
          selectedValue={selectedPlan?.toString() ?? ALL_FILTER_VALUE}
          onSelectedChange={(value) => {
            onSelectedPlanChange(
              value === ALL_FILTER_VALUE ? undefined : Number(value)
            )
          }}
          options={planOptions}
        />
      )}
      {isFiltering && (
        <Mtds.Button
          data-variant='secondary'
          className='self-end'
          onClick={resetOrgFilters}
        >
          Fjern filtre
          <XIcon />
        </Mtds.Button>
      )}
    </Mtds.Grid>
  )
}
